import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-500 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-lg font-semibold font-heading tracking-wide">51吃瓜</span>
            <p className="mt-4 text-sm leading-relaxed text-background-50/80 max-w-[260px]">
              {footerData.description}
            </p>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/20">
          <div className="mb-4">
            <h4 className="text-sm font-semibold mb-3 text-background-50">合作伙伴</h4>
            <p className="text-sm text-background-50/50">优质合作伙伴持续招募中，期待与你携手共创更精彩的内容生态。</p>
          </div>
          <p className="text-sm text-background-50/50">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}